export enum ERequestStatus {
    ALL = '...',
    DONE = 'DONE',
    ERROR = 'ERROR',
    NEW = 'NEW',
    RUNNING = 'RUNNING',
    CANCELED = 'CANCELED',
}
